import $ from 'jquery';
import BaseClass from '../../libs/base/BaseClass';

/**
 * タブ切替の基礎クラス
 * @example
 * <input type="radio" name="test30" data-tab_target="person1" data-tab_target_child="person1_same">
 * <input type="radio" name="test30" data-tab_target="person1" data-tab_target_child="person1_different">
 *
 * <div class="tab_target" data-tab_target_id="person1" data-tab_target_child_id="person1_same">
 * </div><!-- /tab_target -->
 * <div class="tab_target" data-tab_target_id="person1" data-tab_target_child_id="person1_different">
 * </div><!-- /tab_target -->
 */
export default class TabBaseClass extends BaseClass {
  constructor(_id) {
    super();
    this.name = 'ToggleBaseClass';

    this.CL_ACTIVE = 'isActive';

    this.onClickListener = this.onClick.bind(this);

    this.id = _id;

    this.clickType = null;

    this.C_TYPE_RADIO = 'radio';
    this.C_TYPE_A = 'a';
  }

  onCreate() {
    this.clickTarget = $('[data-tab_target=' + this.id + ']');
    this.target = $('[data-tab_target_id=' + this.id + ']');

    if (this.clickTarget.attr('type') === 'radio') {
      this.clickType = this.C_TYPE_RADIO;
      if (this.clickTarget.filter(':checked').length > 0) {
        this.onChange(this.clickTarget.filter(':checked').attr('data-tab_target_child'));
      }
    } else {
      this.clickType = this.C_TYPE_A;
      this.onChange(this.clickTarget.eq(0).attr('data-tab_target_child'));
    }
    this.clickTarget.on('click', this.onClickListener);
  }

  onClick(e) {
    if (this.clickType === this.C_TYPE_A) { e.preventDefault(); }
    const cId = $(e.currentTarget).attr('data-tab_target_child');
    this.onChange(cId);
  }

  onChange(_cId) {
    this.target.hide().filter('[data-tab_target_child_id=' + _cId + ']').show();
    $(window).trigger('resize');
    if (this.clickType === this.C_TYPE_A) {
      this.clickTarget.removeClass(this.CL_ACTIVE).filter('[data-tab_target_child=' + _cId + ']').addClass(this.CL_ACTIVE);
    }
  }
}
